<template>
    <div>        
        <!-- 상단 제목 -->
        <div class="topbanner">
            <h2>{{page_title}}</h2>
        </div>
        <!--// 상단 제목 -->
        <!-- 메인 컨텐츠 영역 -->
        <article class="main_contents">
            <div class="main_contents_insub" v-html="page_contents"></div>
        </article>
        <!--// 메인 컨텐츠 영역 -->        
    </div>
</template>

<script>
export default {
    data() {
        return {
            page_title: "",
            page_contents: ""
        }
    },
    computed: {
        contents_no: function() {
            return this.$route.params.contents_no
        }
    },
    watch: {
        contents_no: function() {
            this.loadPageContents();
        }
    },
    mounted() {
        this.loadPageContents();
    },
    methods: {
        loadPageContents() {
            this.$store.commit('setMenuNo', 0);
            this.$http.get('/api/contents.do',{
                params: {
                    contents_no: this.contents_no
                }
            }).then((response) => {
                if(response.data.retval == this.CONSTANT.SUCCESS) {
                    this.page_title = response.data.pageInfo.title;
                    this.page_contents = response.data.pageInfo.contents;                    
                }
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/Contents.vue